// =============================================================
// highlevelConversationsService
// Service layer for HighLevel Conversations API (WhatsApp/SMS/Email).
// Live mode (future): https://services.leadconnectorhq.com/conversations/
// v1: mock JSON threads with SLA metadata.
// =============================================================

import { CONVERSATIONS, KPIS } from "../data/mockData";

const LIVE_API_ENABLED = false;
const simulateLatency = (data, ms = 120) => new Promise((res) => setTimeout(() => res(data), ms));

export const highlevelConversationsService = {
  isLive: () => LIVE_API_ENABLED,

  async listConversations() {
    return simulateLatency([...CONVERSATIONS]);
  },

  async getConversationForContact(contactId) {
    const convo = CONVERSATIONS.find((c) => c.contact_id === contactId) || null;
    return simulateLatency(convo);
  },

  /** First-response SLA snapshot (mirrors HighLevel SLA reporting concepts) */
  async slaSnapshot() {
    return simulateLatency({
      avg_first_response_mins: KPIS.avg_first_response_mins,
      target_mins: 15,
      sla_met_pct: 74,
      buckets: [
        { bucket: "< 5 min", count: 34 },
        { bucket: "5–15 min", count: 41 },
        { bucket: "15–60 min", count: 29 },
        { bucket: "1–4 h", count: 16 },
        { bucket: "> 4 h", count: 8 },
      ],
    });
  },
};
